import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfExporterService {
  private loadTheSpinner$: Subject<boolean> = new Subject()
  private loadSpinner$ = this.loadTheSpinner$.asObservable();

  public informComplexChartForConfigChange$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { }

  public loadTheSpinner(loadSpinner) {
    this.loadTheSpinner$.next(loadSpinner)
  }

  public get loadSpinner(): Observable<boolean> {
    return this.loadSpinner$
  }
}
